import clsx from 'clsx';
import type { ReactNode } from 'react';

type BadgeVariant = 'green' | 'red' | 'amber' | 'grey' | 'blue' | 'default';

interface BadgeProps {
  children: ReactNode;
  variant?: BadgeVariant;
  className?: string;
}

const variantStyles: Record<BadgeVariant, string> = {
  green: 'bg-green-100 text-green-800',
  red: 'bg-red-100 text-red-800',
  amber: 'bg-amber-100 text-amber-800',
  grey: 'bg-gray-100 text-gray-700',
  blue: 'bg-blue-100 text-blue-800',
  default: 'bg-gray-100 text-gray-700',
};

export default function Badge({ children, variant = 'default', className }: BadgeProps) {
  return (
    <span
      className={clsx(
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium',
        variantStyles[variant],
        className,
      )}
    >
      {children}
    </span>
  );
}

/** Map EntityCashFlowStatus to the correct Badge variant */
export function statusVariant(
  status: string,
): BadgeVariant {
  switch (status) {
    case 'AGREED':
      return 'green';
    case 'SUBMITTED':
      return 'blue';
    case 'IN_PROGRESS':
      return 'amber';
    case 'NOT_STARTED':
      return 'grey';
    default:
      return 'default';
  }
}
